module.exports = __webpack_public_path__ + "862c38230d5dc61499cd3c1b3fe44c5b.svg";